"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSingleCardActivityStyle;

function createSingleCardActivityStyle(_ref) {
  var bubbleMaxWidth = _ref.bubbleMaxWidth,
      bubbleMinWidth = _ref.bubbleMinWidth,
      paddingRegular = _ref.paddingRegular;
  return {
    '& > .bubble-box': {
      maxWidth: bubbleMaxWidth,
      minWidth: bubbleMinWidth
    },
    '& > .filler': {
      minWidth: paddingRegular
    }
  };
}